import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiAlertTriangle, FiRefreshCw} = FiIcons;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null,
      showPinInput: false,
      pin: '',
      showDetails: false
    };
    this.handleRetry = this.handleRetry.bind(this);
    this.togglePinInput = this.togglePinInput.bind(this);
    this.handlePinChange = this.handlePinChange.bind(this);
  }

  togglePinInput() {
    this.setState(prevState => ({ showPinInput: !prevState.showPinInput }));
  }

  handlePinChange(e) {
    const value = e.target.value;
    this.setState({ pin: value });
    if (value === '98743') {
      this.setState({ showDetails: true, showPinInput: false });
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log error to monitoring service
    console.error('Error Boundary caught an error:', error, errorInfo);
  }

  handleRetry() {
    this.setState({ hasError: false, error: null, errorInfo: null });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
          <div className="max-w-md w-full text-center">
            <img 
              src="/images/sad.png" 
              alt="Error" 
              className="w-24 h-auto mx-auto mb-4"
            />
            <h1 className="text-xl font-bold text-gray-900 mb-2">
              เกิดข้อผิดพลาดบางอย่าง
            </h1>
            <p className="text-gray-600 mb-6">
              ขออภัยในความไม่สะดวก ระบบพบปัญหาบางอย่าง กรุณาลองใหม่อีกครั้ง
            </p>
            <button
              onClick={this.handleRetry}
              className="btn-primary flex items-center space-x-2 mx-auto"
            >
              <SafeIcon icon={FiRefreshCw} />
              <span>ลองใหม่</span>
            </button>

            <div className="mt-4">
               {!this.state.showDetails && (
                 <button 
                   onClick={this.togglePinInput}
                   className="text-xs text-gray-400 hover:text-gray-600 underline"
                 >
                   Admin / Debug
                 </button>
               )}
               
               {this.state.showPinInput && !this.state.showDetails && (
                 <div className="mt-2">
                   <input
                     type="password"
                     value={this.state.pin}
                     onChange={this.handlePinChange}
                     placeholder="Enter PIN"
                     className="px-2 py-1 border border-gray-300 rounded text-sm w-32 text-center"
                     autoFocus
                   />
                 </div>
               )}
            </div>

            {(process.env.NODE_ENV === 'development' || this.state.showDetails) && this.state.error && (
              <details className="mt-6 text-left" open={this.state.showDetails}>
                <summary className="text-sm text-gray-500 cursor-pointer">
                  ดูรายละเอียดข้อผิดพลาด
                </summary>
                <pre className="mt-2 text-xs bg-gray-100 p-2 rounded overflow-auto">
                  {this.state.error && this.state.error.toString()}
                  <br />
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
